<template>
	<div>
		  <button class="button mt-3 cont-button" :class="{'full-width': fullWidth}" @click="$emit('goToCheckout')"> 
			  <slot>Continue</slot> </button>
            <div v-if="show_save_button" class="mt-3" id="save-and-continue-la"> <a class="pointer" @click="$emit('saveModuleGoDraftsPage')">Save and Continue Later</a></div>
	</div>
</template>
<script>


export default {
	props:['fullWidth','show_save_button'],
	data() {
		return{

		}	
	},
	methods : {

	}
}
</script>
<style scoped src="./Shopify.css">
</style>



// WEBPACK FOOTER //
// src/components/shopify/ShopifyCheckoutButton.vue